import React, { useEffect, useState } from 'react';
import {
  Alert,
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { marksAPI } from '../../services/api';

const StudentMarks = () => {
  const [exams, setExams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadMarks = async () => {
      try {
        setLoading(true);
        setError('');
        const response = await marksAPI.getMarks({});
        setExams(Array.isArray(response.data) ? response.data : []);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to load marks');
      } finally {
        setLoading(false);
      }
    };

    loadMarks();
  }, []);

  return (
    <Box>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        My Marks
      </Typography>

      {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}

      <Paper sx={{ p: 3 }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
            <CircularProgress />
          </Box>
        ) : (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Exam</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell align="right">Subjects</TableCell>
                  <TableCell align="right">Marks</TableCell>
                  <TableCell align="right">Percentage</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {exams.length > 0 ? exams.map((exam) => (
                  <TableRow key={exam.exam_id} hover>
                    <TableCell>{exam.exam_name}</TableCell>
                    <TableCell>{exam.exam_type}</TableCell>
                    <TableCell align="right">{exam.subjects_count || 0}</TableCell>
                    <TableCell align="right">
                      {exam.total_obtained || 0}/{exam.total_max || 0}
                    </TableCell>
                    <TableCell align="right">{exam.percentage || 0}%</TableCell>
                  </TableRow>
                )) : (
                  <TableRow>
                    <TableCell colSpan={5} align="center">No marks published yet.</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Paper>
    </Box>
  );
};

export default StudentMarks;
